import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        let clone: HttpRequest<any>;
        const route = request.url;

        if (route.indexOf('goesapp/reference/data') >= 0) {
            return next.handle(request);
        } else {
            clone = request.clone({ withCredentials: true });
        }
        return next.handle(clone);
    }
}
